var _g, _g2, _g3, _g4, _path, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1750_32320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 32
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cb00ba32aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H35.3103V32H0V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1750_32320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1750_32320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -6,
    width: 46,
    height: 45
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "2a5261153e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.69556 -5.81055L40.8493 8.10325L27.8119 38.2297L-4.3418 24.3159L8.69556 -5.81055Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1750_32320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1750_32320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -6,
    width: 46,
    height: 45
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "7dd187b708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.69556 -5.81055L40.8493 8.10325L27.8119 38.2297L-4.3418 24.3159L8.69556 -5.81055Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1750_32320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.51006 30.3532C7.7615 29.4839 6.07328 28.4739 4.45978 27.3575C3.32472 26.5572 2.42529 25.4696 1.88363 24.2009C0.971271 22.2411 0.399432 20.2038 0.38219 18.0443C0.364949 17.3101 0.405179 16.5716 0.363512 15.8273C0.308915 14.2095 0.738512 12.6348 1.60633 11.277C2.98851 8.85606 4.75144 6.65634 6.82041 4.78278C8.22989 3.46381 9.89799 2.45232 11.7356 1.82301C12.3664 1.59169 13.0216 1.37186 13.6652 1.17502C16.6164 0.300022 19.5991 -0.00313896 22.6135 0.910654C23.5029 1.18364 24.431 1.3618 25.3635 1.59744C26.4483 1.87042 27.3994 2.45088 28.2859 3.11324C30.921 5.03709 32.9741 7.46238 34.1997 10.5084C34.8808 12.2296 35.2241 14.0831 35.1537 15.9265C35.1164 17.1118 35.102 18.3072 34.8218 19.4724C33.7543 24.2655 30.8405 27.7023 26.7356 30.1477C24.5647 31.4164 22.0604 32.0371 19.5503 31.9581C16.7098 31.9308 13.875 31.5701 11.102 30.8733C10.5058 30.6994 9.89656 30.4925 9.51006 30.3532Z",
    fill: "#5B96A9"
  }))))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.89969 21.7715C9.66406 22.566 10.6195 22.9884 11.7603 23.0445C11.9715 23.0804 12.1871 23.1034 12.4083 23.1034C13.6411 23.1034 14.7359 22.5244 15.4442 21.6264C15.8322 21.1723 16.0764 20.6666 16.1741 20.1063C16.2373 19.8261 16.2747 19.5359 16.2747 19.237C16.2747 17.1005 14.5434 15.3692 12.4083 15.3692C11.5376 15.3692 10.7373 15.6609 10.0908 16.145C10.0893 16.0962 10.0822 16.0517 10.0822 15.9999C10.0822 13.9496 11.6454 11.9008 14.7704 9.85194L14.3164 9.14648C9.88102 11.9008 7.66406 14.9252 7.66406 18.2183C7.66406 19.7298 8.07642 20.9137 8.89969 21.7715Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1750_32320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 9,
    height: 15
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "5eb7289b2e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.0342 9.10352H27.8531V23.1409H19.0342V9.10352Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1750_32320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.3604 23.0488C23.5644 23.0818 23.7727 23.1034 23.9854 23.1034C26.1219 23.1034 27.8532 21.3721 27.8532 19.237C27.8532 17.1005 26.1219 15.3692 23.9854 15.3692C23.0917 15.3692 22.2713 15.6752 21.6161 16.1853C21.6132 16.1235 21.6046 16.066 21.6046 15.9999C21.6046 13.9496 23.1678 11.9008 26.2928 9.85194L25.8388 9.14648C21.4035 11.9008 19.1865 14.9252 19.1865 18.2183C19.1865 19.7313 19.5974 20.9152 20.4207 21.7715C21.2038 22.5847 22.1851 23.0071 23.3604 23.0488Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.1eb85275052f60eed194be1c522b06bf.svg";
export { ForwardRef as ReactComponent };